<template>
  <PageContent
    :can-show-select-favorite-list-dialog="canShowSelectFavoriteListDialog"
    class="tw-overflow-hidden"
    :page-params="pageParams"
  >
    <div class="tw-my-2 lg:tw-my-4">
      <SnowLocationHeader
        :is-page-header="true"
        :location="location"
      />
    </div>
    <SnowLocationNavigation
      :location="location"
      :selected-tab-title="selectedTabTitle"
    />
    <slot name="header" />
    <div class="tw--mt-2">
      <slot />
    </div>
  </PageContent>
</template>

<script>
export default {
  name: 'SnowLocationPageContent',

  props: {
    canShowSelectFavoriteListDialog: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      default: null,
    },
    selectedTabTitle: {
      type: String,
      default: '',
    },
  },

  setup() {
    // Refresh the page after 15 minutes of inactivity
    useRefreshPage();
  },

  computed: {
    pageParams() {
      return this.location ? { location: this.location } : null;
    },
  },
};
</script>
